import { Icon, IconProps } from "../";

export const TriangleRightIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M19.5 11.134C20.1667 11.5189 20.1667 12.4811 19.5 12.866L7.5 19.7942C6.83333 20.1791 6 19.698 6 18.9282V5.0718C6 4.302 6.83333 3.82088 7.5 4.20578L19.5 11.134Z" />
    </Icon>
  );
};
